// extracted by mini-css-extract-plugin
export default {"header":"index_header_SuCd-","user":"index_user_Oj-Ld"};